export const blockUser = async (apiCall, profileId) => {
  try {
    const response = await apiCall(`/api/block/${profileId}`, {
      method: 'POST',
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      throw new Error(data.message || `Error: ${response.status}`);
    }

    return {
      success: true,
      message: data.message,
      data: data.data,
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Block user error:', error.message);
    }
    
    return {
      success: false,
      error: error.message || 'Failed to block user. Please try again.',
    };
  }
};

export const unblockUser = async (apiCall, profileId) => {
  try {
    const response = await apiCall(`/api/block/${profileId}`, {
      method: 'DELETE',
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok || !data.success) {
      throw new Error(data.message || `Error: ${response.status}`);
    }

    return {
      success: true,
      message: data.message,
      data: data.data,
    };
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Unblock user error:', error.message);
    }
    
    return {
      success: false,
      error: error.message || 'Failed to unblock user. Please try again.',
    };
  }
};

export const fetchBlockedUsers = async (apiCall, cursor = null) => {
  try {
    const params = new URLSearchParams();
    if (cursor) params.append('cursor', cursor);

    const response = await apiCall(`/api/block?${params.toString()}`);
    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || `HTTP error! status: ${response.status}`);
    }

    return {
      blockedUsers: data.data.blockedUsers || [],
      nextCursor: data.data.nextCursor || null,
      hasMore: data.data.hasMore || false,
    };
  } catch (error) {
    throw error;
  }
};